<template>
<div id="ink-container">
	<div class="panel panel-default">
		<div class="panel-body">
		<div class="control-group">
			<ul class="ink-list">
				<li v-for="ink in inks">
					<label class="control control--checkbox">{{ink.name}}
						<input type="checkbox" v-model="ink.selected"/>
						<div class="control__indicator"></div>
					</label>
				</li>
				<button class="btn btn-primary btn-xs pull-right" style="margin-top:20px;" @click="reload()">Reload</button>
			</ul>
		</div>
		</div>
	</div>
</div>
</template>
<script>
import _ from 'lodash';
export default {
	props: ['inks'],
	methods: {
		reload() {
			console.log(this.inks);
			// console.log(this.selectedInks);

			const selectedInks = _.filter(this.inks, ink => ink.selected);

			// const allSelected = !this.selectedInks.some(ink => !ink.selected);
			// if (allSelected) return this.$emit("reload-inks");
			// const inks = [];
			// _.each(this.selectedInks, ink => {
			// 	if (ink.selected) inks.push(ink.name)
			// });
			this.$emit("reload-inks", selectedInks);
		}
	}
}
</script>
<style lang="">
#ink-container {
	position: absolute;
	left: 70px;
	top: 80px;
	width: 200px;
	z-index: 100000000;
}
.ink-list {
	padding:0px;
}
.ink-list > li {
	list-style-type: none;
	padding:5px;
}
.control {
  position: relative;
  padding-left: 30px;
  margin-bottom: 0px;
  cursor: pointer;
  padding-top:2px;
}
.control input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.control__indicator {
  position: absolute;
  top: 2px;
  left: 0;
  height: 20px;
  width: 20px;
  background: #e6e6e6;
  box-sizing: content-box;
  font-weight: normal;
}
.control:hover input ~ .control__indicator,
.control input:focus ~ .control__indicator {
  background: #ccc;
}
.control input:checked ~ .control__indicator {
  background: #2aa1c0;
}
.control:hover input:not([disabled]):checked ~ .control__indicator,
.control input:checked:focus ~ .control__indicator {
  background: #0e647d;
}
.control input:disabled ~ .control__indicator {
  background: #e6e6e6;
  opacity: 0.6;
  pointer-events: none;
}
.control__indicator:after {
  content: '';
  position: absolute;
  display: none;
}
.control input:checked ~ .control__indicator:after {
  display: block;
}
.control--checkbox .control__indicator:after {
  left: 8px;
  top: 4px;
  width: 3px;
  height: 8px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.control--checkbox input:disabled ~ .control__indicator:after {
  border-color: #7b7b7b;
}
</style>



// WEBPACK FOOTER //
// Inks.vue?266fff38